import { get } from 'lodash';
import {
  ocdrContractTermFiveYear,
  ocdrContractTermOneYear,
  ocdrContractTermThreeYear
} from '../../utils/constant';

export const getCategoryWiseStateDataForProducts = products => {
  const productsObject = {};
  products.forEach(product => {
    if (!productsObject[product.productCategory.name]) {
      productsObject[product.productCategory.name] = {};
    }
    if (product.productSubcategory) {
      if (
        !productsObject[product.productCategory.name][
          product.productSubcategory.name
        ]
      ) {
        productsObject[product.productCategory.name][
          product.productSubcategory.name
        ] = [product];
      } else {
        productsObject[product.productCategory.name][
          product.productSubcategory.name
        ].push(product);
      }
    }
  });

  return productsObject;
};

export const getCategoryDataForMicrosoftCloudProducts = products => {
  const productsObject = {};
  products.forEach(product => {
    if (!product.productSubcategory) {
      if (!productsObject[product.productCategory.name]) {
        productsObject[product.productCategory.name] = [];
      }
      productsObject[product.productCategory.name].push(product);
    }
  });
  return productsObject;
};

const optionTermToproductTermKey = {
  [ocdrContractTermOneYear]: 'oneYear',
  [ocdrContractTermThreeYear]: 'threeYears',
  [ocdrContractTermFiveYear]: 'fiveYears'
};

const getServiceListTotal = (list, discountKey) => {
  return list.reduce(
    (acc, item) => {
      if (item.priceType === 'oneTime') {
        acc.oneTime += item.price * (item.quantity || 0);
      }
      if (item.priceType === 'recurring') {
        const priceToAdd = item.price * (item.quantity || 0);
        let discountAmount = 0;
        if (discountKey && item.productDiscount) {
          discountAmount =
            priceToAdd * (item.productDiscount[discountKey] / 100 || 0);
        }
        acc.monthly += priceToAdd - discountAmount;
      }
      return acc;
    },
    {
      monthly: 0,
      oneTime: 0
    }
  );
};

const getTotalForSubcategoryService = (service, discountKey) => {
  return Object.keys(service).reduce(
    (acc, subKey) => {
      const { monthly, oneTime } = getServiceListTotal(
        service[subKey],
        discountKey
      );
      acc.monthly += monthly;
      acc.oneTime += oneTime;
      return acc;
    },
    {
      monthly: 0,
      oneTime: 0
    }
  );
};

export const getServicesTotals = (
  productData,
  term,
  productName,
  orderData,
  step
) => {
  if(step !== 1){
    term = get(orderData, `contractTerm`, '');
    productName = get(orderData, `productSelectionOCDR`, []);
  }

  const discountKey = optionTermToproductTermKey[term];
  return Object.keys(productData).reduce(
    (acc, key) => {
      if (!productName.includes(key) && key === 'Direct Routing') {
        return acc;
      }
      if (!productName.includes(key) && key === 'Operator Connect') {
        return acc;
      }
      const { monthly, oneTime } = getTotalForSubcategoryService(
        productData[key],
        discountKey
      );
      acc.monthly += monthly;
      acc.oneTime += oneTime;
      return acc;
    },
    {
      monthly: 0,
      oneTime: 0
    }
  );
};

export const getIsQuoteApproveRequired = (currentvalue, matchvalue) => {
  for (const data in currentvalue) {
    if (data === 'Direct Routing' || data === 'Operator Connect') {
      for (const subdata in currentvalue[data]) {
        for (let idx = 0; idx < currentvalue[data][subdata].length; idx++) {
          const fieldData = currentvalue[data][subdata][idx];
          const matchFieldData = matchvalue[data][subdata][idx];

          if (
            fieldData.quantity > 0 &&
            fieldData.price < matchFieldData.price
          ) {
            return true;
          }
        }
      }
    }
  }

  return false;
};

export const getIsQuoteApproveRequiredForMCProduct = (
  currentvalue,
  matchvalue,
  contractTerm
) => {

  if (contractTerm === 'One Month Subscription') {
    return true;
  }

  for (let checkData of currentvalue) {
    const validateDiscount = matchvalue[checkData.category].find(
      data => data.name === checkData.editions
    );

    if (validateDiscount.productBundles.length > 0) {
      for (let bundelData of validateDiscount.productBundles) {
        if (
          checkData.onetimeDiscount > bundelData[checkData.contractTerm] ||
          checkData.monthlyDiscount > bundelData[checkData.contractTerm]
        ) {
          return true;
        }
      }
    }
  }
  return false;
};


export const getOcdrSummaryPayload = (
  orderData,
  hasProductDirectRouting,
  hasProductOperatorConnect,
  hasProductMicrosoftCloud
) => {
  let ocdrSummary = {};

  const term = get(orderData, `contractTerm`, '');
  const discountKey = optionTermToproductTermKey[term];

  if (hasProductDirectRouting) {
    const directRoutingData = get(orderData, `products['Direct Routing']`, '');
    let fieldData = [];
    const { monthly, oneTime } = getTotalForSubcategoryService(
      directRoutingData,
      discountKey
    );
    for (const key in directRoutingData) {
      for (let idx = 0; idx < directRoutingData[key].length; idx++) {
        const fields = directRoutingData[key][idx];
        fieldData.push(fields);
      }
    }
    ocdrSummary.directRouting = {
      fieldData,
      totalMonthlyCharges: monthly,
      totalOneTimeCharges: oneTime
    };
  } else {
    ocdrSummary.directRouting = {};
  }

  if (hasProductOperatorConnect) {
    const operatorConnectData = get(
      orderData,
      `products['Operator Connect']`,
      ''
    );
    let fieldData = [];
    const { monthly, oneTime } = getTotalForSubcategoryService(
      operatorConnectData,
      discountKey
    );
    for (const key in operatorConnectData) {
      for (let idx = 0; idx < operatorConnectData[key].length; idx++) {
        const fields = operatorConnectData[key][idx];
        fieldData.push(fields);
      }
    }
    ocdrSummary.operatorConnect = {
      fieldData,
      totalMonthlyCharges: monthly,
      totalOneTimeCharges: oneTime
    };
  } else {
    ocdrSummary.operatorConnect = {};
  }

  if (hasProductDirectRouting || hasProductOperatorConnect) {
    ocdrSummary.hardwareData = orderData.hardwareData;
    ocdrSummary.ocdrServiceAdd = orderData.ocdrServiceAdd;
  } else {
    ocdrSummary.hardwareData = {};
    ocdrSummary.ocdrServiceAdd = {};
  }

  if(hasProductMicrosoftCloud) {
    ocdrSummary.ocdrProductAdd = orderData.ocdrProductAdd;
  } else {
    ocdrSummary.ocdrProductAdd = {};
  }

  return ocdrSummary;
};